import React, { useEffect } from 'react'
import { toast } from 'react-toastify';

const Flash = (props: {
  notice?: string
  alert?: string
  error?: string
}) => {

  useEffect(() => {
    props.notice && toast(props.notice)
    props.alert && toast.warning(props.alert)
    props.error && toast.error(props.error)
  }, [props])

  return  <div />
}

export default Flash